<template>
  <!--<nav>
    <router-link to="/">Home</router-link> |
  </nav> -->
  <router-view/>
</template>

<style>
:root {
            --primary-color: #d6336c; /* Pink */
            --secondary-color: #f7e6e9; /* Light Pink */
            --dark-color: #333;
            --light-color: #fff;
            --shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        body {
            font-family: 'Arial', sans-serif;
            color: var(--dark-color);
            line-height: 1.6;
            background-color: var(--light-color);
        }
    .page-title {
      font-size: 1.8rem;
    font-weight: bold;
    color: crimson;
    font-family: Arial, Helvetica, sans-serif;
    margin-top: 2rem;
    margin-bottom: 0.5rem; 
    display: block; 
    text-align: left;
    }
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
